/**
 * @generated SignedSource<<2488d5f650ec53a85a154e378b9ee8c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateCustomFieldDefinitionInput = {
  id?: string | null;
  displayName?: string | null;
  readOnly?: boolean | null;
  avaRef?: number | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type UpdateCustomFieldDefinitionMutation$variables = {
  input: UpdateCustomFieldDefinitionInput;
};
export type UpdateCustomFieldDefinitionMutation$data = {
  readonly updateCustomFieldDefinition: {
    readonly customFieldDefinition: {
      readonly node: {
        readonly id: string;
        readonly displayName: string | null;
        readonly avaRef: number | null;
      } | null;
    } | null;
  } | null;
};
export type UpdateCustomFieldDefinitionMutation$rawResponse = {
  readonly updateCustomFieldDefinition: {
    readonly customFieldDefinition: {
      readonly node: {
        readonly id: string;
        readonly displayName: string | null;
        readonly avaRef: number | null;
      } | null;
    } | null;
  } | null;
};
export type UpdateCustomFieldDefinitionMutation = {
  variables: UpdateCustomFieldDefinitionMutation$variables;
  response: UpdateCustomFieldDefinitionMutation$data;
  rawResponse: UpdateCustomFieldDefinitionMutation$rawResponse;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCustomFieldDefinitionPayload",
    "kind": "LinkedField",
    "name": "updateCustomFieldDefinition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomFieldDefinitionTypeEdge",
        "kind": "LinkedField",
        "name": "customFieldDefinition",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomFieldDefinition",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avaRef",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateCustomFieldDefinitionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateCustomFieldDefinitionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c36643ac15740391c6213ca7cbf2c647",
    "id": null,
    "metadata": {},
    "name": "UpdateCustomFieldDefinitionMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateCustomFieldDefinitionMutation(\n  $input: UpdateCustomFieldDefinitionInput!\n) {\n  updateCustomFieldDefinition(input: $input) {\n    customFieldDefinition {\n      node {\n        id\n        displayName\n        avaRef\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1d4fe4326d850fc02e04d61596d33e43";

export default node;
